export const fireworks_aiModels = {
    id: "fireworks-ai",
    name: "Fireworks AI",
    api: "https://api.fireworks.ai/inference/v1/",
    npm: "@ai-sdk/openai-compatible",
    doc: "https://fireworks.ai/docs/",
    env: ["FIREWORKS_API_KEY"],
    models: {
        "accounts/fireworks/models/qwen3-235b-a22b": {
            id: "accounts/fireworks/models/qwen3-235b-a22b",
            name: "Qwen3 235B-A22B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-04-29",
            last_updated: "2025-04-29",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.22,
                output: 0.88,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        "accounts/fireworks/models/gpt-oss-20b": {
            id: "accounts/fireworks/models/gpt-oss-20b",
            name: "GPT OSS 20B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-05",
            last_updated: "2025-08-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.05,
                output: 0.2,
            },
            limit: {
                context: 131072,
                output: 32768,
            },
        },
        "accounts/fireworks/models/deepseek-v3-0324": {
            id: "accounts/fireworks/models/deepseek-v3-0324",
            name: "Deepseek V3 03-24",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-03-24",
            last_updated: "2025-03-24",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.9,
                output: 0.9,
            },
            limit: {
                context: 160000,
                output: 16384,
            },
        },
        "accounts/fireworks/models/qwen3-coder-480b-a35b-instruct": {
            id: "accounts/fireworks/models/qwen3-coder-480b-a35b-instruct",
            name: "Qwen3 Coder 480B A35B Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            release_date: "2025-07-22",
            last_updated: "2025-07-22",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.45,
                output: 1.8,
            },
            limit: {
                context: 256000,
                output: 32768,
            },
        },
        "accounts/fireworks/models/deepseek-r1-0528": {
            id: "accounts/fireworks/models/deepseek-r1-0528",
            name: "Deepseek R1 05/28",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-05",
            release_date: "2025-05-28",
            last_updated: "2025-05-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 3,
                output: 8,
            },
            limit: {
                context: 160000,
                output: 16384,
            },
        },
        "accounts/fireworks/models/glm-4p5-air": {
            id: "accounts/fireworks/models/glm-4p5-air",
            name: "GLM 4.5 Air",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-08-01",
            last_updated: "2025-08-01",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.22,
                output: 0.88,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
        "accounts/fireworks/models/kimi-k2-instruct": {
            id: "accounts/fireworks/models/kimi-k2-instruct",
            name: "Kimi K2 Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-07-11",
            last_updated: "2025-07-11",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 1,
                output: 3,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        "accounts/fireworks/models/gpt-oss-120b": {
            id: "accounts/fireworks/models/gpt-oss-120b",
            name: "GPT OSS 120B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            release_date: "2025-08-05",
            last_updated: "2025-08-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.15,
                output: 0.6,
            },
            limit: {
                context: 131072,
                output: 32768,
            },
        },
        "accounts/fireworks/models/glm-4p5": {
            id: "accounts/fireworks/models/glm-4p5",
            name: "GLM 4.5",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-29",
            last_updated: "2025-07-29",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.55,
                output: 2.19,
            },
            limit: {
                context: 131072,
                output: 131072,
            },
        },
        "accounts/fireworks/models/deepseek-v3p1": {
            id: "accounts/fireworks/models/deepseek-v3p1",
            name: "DeepSeek V3.1",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-07",
            release_date: "2025-08-21",
            last_updated: "2025-08-21",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.56,
                output: 1.68,
            },
            limit: {
                context: 163840,
                output: 163840,
            },
        },
    },
};
export default fireworks_aiModels;
//# sourceMappingURL=fireworks-ai.js.map